<script setup>
import {computed} from 'vue'
import {useLightboxStore} from '@/stores/lightbox'
import {useViewStore} from '@/stores/view'
import {useAppStore} from '@/stores/appStore'

const props = defineProps({
    item: Object,
    value: String,
    viewId: String
})

// Pinia Stores
const viewStore = useViewStore(props.viewId)
const lightboxStore = useLightboxStore()
const appStore = useAppStore()

const isImage = computed(() => {
    return (
        props.item?.mimetype &&
        props.item.mimetype.indexOf('image') === 0 // e.g. image/jpeg image/gif
    )
})

const href = computed(() => {
    return appStore.fileSrc(props.value)
})

// Setup initialization logic
if (isImage.value) {
    lightboxStore.add({
        id: props.value,
        title: props.value,
        src: appStore.fileSrc(props.value),
        onShow() {
            viewStore.onClick(props.item.id)
        }
    })
}

const onClick = async () => {
    if (isImage.value) {
        await lightboxStore.show(props.value)
    }
}
</script>

<template>
    <a
        v-if="isImage"
        :title="value"
        href="#"
        @click.prevent="onClick"
    >
        {{ value }}
    </a>
    <a v-else :href="href" :title="value">{{ value }}</a>
</template>